import { JeecgListMixin } from "@/utils/JeecgListMixin";
import { getAction } from "@/api/manage";
export default {
  name: "Question",
  mixins: [JeecgListMixin],
  data: function data() {
    return {
      columns: [{
        title: '#',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        fixed: "left",
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        title: "试卷",
        align: "center",
        dataIndex: "paperId_dictText"
      }, {
        title: '状态',
        align: 'center',
        dataIndex: 'userPaperStatus_dictText',
        sorter: true
      }, {
        title: '用时',
        align: 'center',
        dataIndex: 'duration',
        sorter: true,
        customRender: function customRender(time, row) {
          if (row.userPaperStatus == 0) {
            return "";
          }
          var minutes = Math.floor(time / 60);
          var seconds = Math.floor(time % 60);
          return minutes + ':' + seconds;
        }
      }, {
        title: '总得分',
        align: 'center',
        dataIndex: 'gotScore',
        sorter: true,
        customRender: function customRender(v) {
          if (v == null) {
            return '--';
          } else {
            return v;
          }
        }
      }, {
        title: '开考时间',
        align: 'center',
        dataIndex: 'createTime',
        sorter: true
      }, {
        title: '交卷时间',
        align: 'center',
        dataIndex: 'submitTime',
        sorter: true
      },
      // {
      //   title: '批改时间',
      //   align: 'center',
      //   dataIndex: 'reviewTime',
      //   sorter: true,
      // },
      // {
      //   title: '批改人',
      //   align: 'center',
      //   dataIndex: 'reviewUserId_dictText',
      // },
      {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        fixed: 'right',
        width: 147,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      url: {
        list: '/teaching/teachingUserPaper/myAnswerPaper'
      }
    };
  },
  created: function created() {},
  methods: {
    searchQuery: function searchQuery() {
      this.loadData();
    },
    toMyPaper: function toMyPaper() {
      this.$router.push({
        path: '/user/myPaper'
      });
    },
    handleReview: function handleReview(record) {
      var path = {
        path: '/user/userPaper',
        query: {
          id: record.id
        }
      };
      // let route = this.$router.resolve(path)
      // window.open(route.href, '_blank')
      this.$router.push(path);
    }
  }
};